import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['classTypeInput', 'fieldset']

  connect() {
    this.toggleCategorySelect()
  }

  toggleCategorySelect() {
    const currentType = this.classTypeInputTarget.value

    this.fieldsetTargets.forEach((fieldset) => {
      const type = fieldset.dataset.classType
      const show = type === currentType

      fieldset.hidden = !show
      fieldset.disabled = !show
    })
  }
}
